import { Modal, Select } from "antd";
import ChantPopConfirm from "../../../../CommonComponents/ChantTooltip/ChantPopConfirm";
import React from "react";
import ChantButton from "../../../../CommonComponents/ChantButton/ChantButton";
import DescriptionText from "../../../../CommonComponents/DescriptionText";

const OrderUpdateModal = ({
  openUpdateModal,
  setOpenUpdateModal,
  selectedRows,
  editedRecords,
  handleRecordStatusChange,
  handleUpdateStatus,
  statusUpdateLoading,
  orderStatus,
  setOrderStatus,
}) => {
  const options = [
    { label: "--Select--", value: "select" },
    { label: "Shipped", value: "shipped" },
    { label: "Picked up", value: "pickedup" },
    { label: "Refunded", value: "refunded" },
    { label: "Unclaimed", value: "unclaimed" },
    { label: "Unfulfilled", value: "unfulfilled" },
  ];

  const handleStatusChange = (value) => {
    setOrderStatus(value);
    selectedRows.forEach((row) => {
      const [id, dbIndex] = row.split("|");

      let records = editedRecords || {};
      records[id] = {
        ...(editedRecords[id] || {}),
      };
      records[id][dbIndex] = value;

      handleRecordStatusChange(records);
    });
  };

  return (
    <Modal
      open={openUpdateModal}
      onCancel={() => {
        setOpenUpdateModal(false);
      }}
      width={500}
      height={500}
      title={"Update Order Status"}
      centered
      footer={[
        <ChantPopConfirm
          key="confirm"
          title={`Update ${selectedRows?.length} ${selectedRows?.length > 1 ? "orders" : "order"}?`}
          onConfirm={handleUpdateStatus}
          okText="Yes"
          cancelText="No"
        >
          <ChantButton
            key="submit"
            type="primary"
            disabled={orderStatus === "select" || statusUpdateLoading}
            loading={statusUpdateLoading}
          >
            Update
          </ChantButton>
        </ChantPopConfirm>,
      ]}
    >
      <DescriptionText>
        <p style={{ marginBottom: 0 }}>
          {`NOTE: Clicking update will update all selected orders (${selectedRows?.length})`}
        </p>
      </DescriptionText>

      <div
        style={{
          paddingTop: 20,
          width: "50%",
          maxHeight: "500px",
          overflow: "auto",
        }}
      >
        <Select
          disabled={statusUpdateLoading}
          value={orderStatus}
          popupMatchSelectWidth={false}
          onChange={handleStatusChange}
          style={{ width: "100%" }}
          options={options?.map((item) => ({
            value: item.value,
            label: <span>{item.label}</span>,
          }))}
        />
      </div>
    </Modal>
  );
};

export default OrderUpdateModal;
